import { render, staticRenderFns } from "./PersonalData.vue?vue&type=template&id=ce8eff18&scoped=true&"
import script from "./PersonalData.vue?vue&type=script&lang=js&"
export * from "./PersonalData.vue?vue&type=script&lang=js&"
import style0 from "./PersonalData.vue?vue&type=style&index=0&id=ce8eff18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8eff18",
  null
  
)

export default component.exports
import {QIcon,QPopupEdit,QInput,QSlideTransition,QBtn,QToggle,QTooltip} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QIcon,QPopupEdit,QInput,QSlideTransition,QBtn,QToggle,QTooltip})
